//Formik
import { useField } from "formik"
import FormikDropDown from "../../../helpers/formikInputs/FormikDropDown"
import FormikTextInput from "../../../helpers/formikInputs/FormikTextInput"
import FormikMultiSelectInput from "../../../helpers/formikInputs/FormikMultiSelectInput"

export default function HousingActivitiesSubstanceInputs({ values, disabled }) {
  const [, , resultHelper] = useField("substanceTest.result")
  const [typeField] = useField("substanceTest.type")
  const [, , outcomeHelper] = useField("substanceTest.outcome")
  const [, , typeOtherHelper] = useField("substanceTest.typeOther")
  const [, , outcomeOtherHelper] = useField("substanceTest.outcomeOther")

  const [, , substanceHelper] = useField("substanceTest.resultSubstance")

  const substances = [
    "Alcohol",
    "Opioids: Heroine",
    "Opioids: Morphine",
    "Opioids: Fentanyl (Prescription Diversion Or Illicit Source)",
    "Opioids: Dilaudid",
    "Opioids: Demerol",
    "Opioids: Percocet",
    "Opioids: Codeine",
    "Opioids: Tylenol 2, 3, 4",
    "Opioids: OxyContin/Oxycodone",
    "Opioids: Non-prescription methadone",
    "Opioids: Non-prescription buprenorphine",
    "Cannabis: Cannabis (Marijuana)",
    "Cannabis: Synthetic Cannabinoids",
    "Sedatives",
    "Hypnotics",
    "Barbiturates",
    "Anxiolytics/Benzodiazepines",
    "Cocaine: Cocaine",
    "Cocaine: Crack",
    "Other Stimulants: Methamphetamine",
    "Other Stimulants: Stimulant medications",
    "Hallucinogens & Psycodelics: PCP",
    "Hallucinogens & Psycodelics: MDMA",
    "Hallucinogens & Psycodelics: LSD",
    "Hallucinogens & Psycodelics: Mushrooms",
    "Hallucinogens & Psycodelics: Mescaline",
    "Hallucinogens & Psycodelics: Salvia",
    "Hallucinogens & Psycodelics: DMT",
    "Inhalants",
    "Psychoactive Substances: Non-prescription GHB",
    "Psychoactive Substances: Ketamine",
    "Psychoactive Substances: MDPV/Bath Salts",
    "Psychoactive Substances: Kratom",
    "Psychoactive Substances: Khat",
    "Psychoactive Substances: Other tranquilizers",
    "Psychoactive Substances: Other downers",
    "Psychoactive Substances: Other sedatives",
    "Psychoactive Substances: Other hypnotics",
    "Tobacco",
    "Nicotine (Including Vape Products)",
  ]

  if (values.activityType === "SubstanceTest") {
    const substanceTypeCheck = (resultValue) => {
      if (typeField.value === "Breathalyzer" && resultValue === "positive") {
        substanceHelper.setValue(["Alcohol"])
      }

      if (resultValue !== "positive") {
        substanceHelper.setValue([])
        outcomeHelper.setValue("")
        outcomeOtherHelper.setValue("")
      }
    }

    const typeSelectionChange = () => {
      typeOtherHelper.setValue("")
      resultHelper.setValue("")
      outcomeHelper.setValue("")
      outcomeOtherHelper.setValue("")
      substanceHelper.setValue([])
    }

    return (
      <>
        <FormikDropDown
          disabled={disabled}
          name={"substanceTest.type"}
          label={"Type of Test"}
          options={[
            { label: "Urinalysis", value: "Urinalysis" },
            { label: "Breathalyzer", value: "Breathalyzer" },
            { label: "Other", value: "Other" },
          ]}
          required={true}
          onChangeCallback={() => {
            typeSelectionChange()
          }}
        />
        {values.substanceTest.type === "Other" ? (
          <FormikTextInput
            disabled={disabled}
            name={"substanceTest.typeOther"}
            label={"Description of Other Test Type"}
            required={true}
            placeholderText={" "}
          />
        ) : null}

        <FormikDropDown
          disabled={disabled}
          name={"substanceTest.result"}
          label={"Test Result"}
          options={[
            { label: "Positive", value: "positive" },
            { label: "Negative", value: "negative" },
            { label: "Inconclusive", value: "inconclusive" },
          ]}
          required={true}
          onChangeCallback={(value) => {
            substanceTypeCheck(value)
          }}
        />
        {values.substanceTest.result === "positive" ? (
          <>
            <FormikMultiSelectInput
              disabled={disabled}
              name={"substanceTest.resultSubstance"}
              label={"Test Result Substance"}
              options={substances}
              required={true}
            />
            <FormikDropDown
              disabled={disabled}
              name={"substanceTest.outcome"}
              label={"Outcome Result"}
              options={[
                "Placed on Corrective Action Plan",
                "Asked to Leave Residence",
                "Transferred to higher level of care",
                "Other",
              ]}
              required={true}
            />
          </>
        ) : null}
        {values.substanceTest.outcome === "Other" ? (
          <FormikTextInput
            disabled={disabled}
            name={"substanceTest.outcomeOther"}
            label={"Outcome Result Other"}
            required={true}
            placeholderText={" "}
          />
        ) : null}
      </>
    )
  } else {
    return null
  }
}
